import React, { ChangeEvent, ReactElement, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import AuthLayout from '../../../../layouts/auth/AuthLayout';
import Button from '../../../common/button/Button';

import { ReactComponent as EmailIcon } from '../../../../resources/icons/email.svg';
import { ReactComponent as HashtagIcon } from '../../../../resources/icons/hashtag.svg';

import './forgot-password.scss';

type Props = {
  initiatePasswordReset: (email: string, mobileNumber: string, onSuccess: () => void) => void;
};

const ForgotPassword = ({ initiatePasswordReset }: Props): ReactElement => {
  const [email, setEmail] = useState<string>('');
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const [mobileNumber, setMobileNumber] = useState<string>('');

  const navigate: NavigateFunction = useNavigate();

  const handleResetPasswordClick = (): void => {
    if (email || mobileNumber) {
      initiatePasswordReset(email, mobileNumber, (): void => setEmailSent(true));
    }
  };

  return (
    <AuthLayout>
      <div className="forgot-password">
        {emailSent ? (
          <>
            <div className="forgot-password__success-message-container">
              <p className="forgot-password__message">Thank you.</p>
              <p className="forgot-password__message">
                Please check your email address and/or mobile number for further instructions.
              </p>
            </div>
            <div className="forgot-password__button-container">
              <Button text="Return Home" onClick={(): void => navigate('/')} auth />
            </div>
          </>
        ) : (
          <>
            <p className="forgot-password__message">
              Please enter the email address and/or mobile number associated with your account:
            </p>
            <div className="forgot-password__input-container">
              <div className="forgot-password__input">
                <EmailIcon className="forgot-password__icon" />
                <input
                  type="text"
                  value={email}
                  onChange={({ target }: ChangeEvent<HTMLInputElement>): void => setEmail(target.value)}
                  placeholder="email"
                />
              </div>
              <div className="forgot-password__input">
                <HashtagIcon className="forgot-password__icon" />
                <input
                  type="text"
                  value={mobileNumber}
                  onChange={({ target }: ChangeEvent<HTMLInputElement>): void => setMobileNumber(target.value)}
                  placeholder="mobile number"
                />
              </div>
            </div>
            <div className="forgot-password__button-container">
              <Button
                text="Reset Password"
                disabled={!email && !mobileNumber}
                onClick={handleResetPasswordClick}
                auth
              />
            </div>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
